import { kebabCase } from 'lodash';

export const convertToRawCss = (styles: Record<string, Record<string, string>>): string => {
    return Object.entries(styles)
        .map(([selector, props]) => {
            const declarations = Object.entries(props)
                .map(([key, value]) => `${kebabCase(key)}: ${value};`)
                .join(' ');

            return `${selector} { ${declarations} }`;
        })
        .join('\n');
};
